import firebase from "firebase/app";

import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import "firebase/messaging";

// firebase init goes here
const firebaseConfig = {
  apiKey: "AIzaSyBHqjcyOgCIYV5QMyitrf53bSVLKfYqffQ",
  authDomain: "shoxadomokai-portfolio.firebaseapp.com",
  databaseURL: "https://shoxadomokai-portfolio.firebaseio.com",
  projectId: "shoxadomokai-portfolio",
  storageBucket: "shoxadomokai-portfolio.appspot.com",
  messagingSenderId: "1089168171695",
  appId: "1:1089168171695:web:0411cfad139abff9eaea5a",
  measurementId: "G-CX6W006027"
};

firebase.initializeApp(firebaseConfig);
firebase
  .firestore()
  .enablePersistence({ synchronizeTabs: true })
  .catch(err => {
    console.log(err.message);
  });

// firebase utils
const db = firebase.firestore();
const storage = firebase.storage();
const auth = firebase.auth();

const currentUser = auth.currentUser;

// firebase collections
const usersCollection = db.collection("users");
const imagesCollection = db.collection("images");
const clientsCollection = db.collection("clients");
const websitesCollection = db.collection("websites");
const caseStudyCollection = db.collection("caseStudies");
const subscriberCollection = db.collection("subscribers");

let messaging;
if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging();
  // set up messsaging
  messaging.usePublicVapidKey(
    "BKU2Qpwf5zeB1DbB71jcCI2cxTRd5Wf_0Ghk82XBt8SSog0lOy2BQOwWT1hMDr1RF5iips7LsTeTh5uEqmn4Kas"
  );
}

export {
  db,
  auth,
  messaging,
  storage,
  currentUser,
  subscriberCollection,
  usersCollection,
  imagesCollection,
  clientsCollection,
  websitesCollection,
  caseStudyCollection
};
